import { Dayjs } from 'dayjs';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import { useStore } from 'src/context/StoreContext';

type SelectMonthYearProp = {
  currentMonth: Dayjs;
  onMonthChange: (monthYear: string) => void;
}

const SelectMonthYear = (props: SelectMonthYearProp) => {
  const { currentMonth, onMonthChange } = props;
  const storeContext = useStore();
  const store = storeContext.store;

  const selectNextMonth = () => {
    const next = nextMonth(currentMonth);
    onMonthChange(next.format('YYYY-MM'));
  };

  const selectPreviousMonth = () => {
    const prev = currentMonth.subtract(1, 'month');
    onMonthChange(prev.format('YYYY-MM'));
  };

  const nextMonth = (date: Dayjs): Dayjs => {
    const newDate = date.add(1, 'month');

    return newDate;
  }

  return (
    <Stack
      direction='row'
      justifyContent={'center'}
      alignItems={'center'} sx={{
        height: '32px',
        borderRadius: '4px 4px 0px 0px',
        my: 'auto',
      }}>
      <Box>
        <IconButton onClick={selectPreviousMonth} title='Previous month'>
          <img src='/images/ic-arrow-left-gray.svg' style={{ width: '24px', height: '24px' }} alt='icon' />
        </IconButton>
      </Box>
      <Typography variant='body2' sx={{ fontSize: '20px', fontWeight: 500, lineHeight: '24px', color: store.palette.calendar.text.color, mx: '10px' }}>
        {currentMonth.format('YYYY')}年{currentMonth.format('MM')}月
      </Typography>
      <Box>
        <IconButton onClick={selectNextMonth} title='Next month'>
          <img src='/images/ic-arrow-right-gray.svg' style={{ width: '24px', height: '24px' }} alt='icon' />
        </IconButton>
      </Box>
    </Stack>
  );
}

export default SelectMonthYear;